export const sectionIdentifier = {
  accountPopover: 'ACCOUNT_POPOVER',
  cartSection: 'CART',
  checkoutNewAddressForm: 'CHECKOUT_NEW_ADDRESS_FORM',
  checkoutPayment: 'CHECKOUT_PAYMENT',
  clipDialog: 'DIALOG_CLIP',
  cotizacionSection: 'COTIZACION',
  envioListToolbar: 'ENVIO_LIST_TOOLBAR',
  listaEnviosSection: 'LISTA_ENVIOS',
  lockerFlujoFinal: 'LOCKER_FLUJO_FINAL',
  lockerItemEnvio: 'LOCKER_ITEM_ENVIO',
  mercadoPago: 'MERCADO_PAGO',
  mercadoPagoOptions: 'MERCADO_OPTIONS',
  movimientoEmpaque: 'MOVIMIENTO_EMPAQUE',
  pagoClip: 'PAGO_CLIP',
  saldoDialogAssigned: 'SALDO_DIALOG_ASSIGNED_COMPRA',
  saldoQr: 'SALDO_QR',
  saldosRecargasYSericios: 'SALDOS_RECARGAS_Y_SERVICIOS',
  tablaCuponesSection: 'TABLA_CUPONES_SECTION',
  tomandoMedidasLocker: 'TOMA_MEDIDAS',
  comprarRecargasYServicios: 'COMPRAR_RECARGAS_Y_SERVICIOS',
  direcciones: 'DIRECCIONES',
  caja: 'CAJA'
};

export const actionSectionIdentifier = {
  aplicarCupon: 'APLICAR_CUPON',
  cambiarModoDeOperacion: 'CAMBIANDO_MODO_OPERACION',
  cancelPayment: 'CANCELAR_PAGO',
  cencelarIntentosPago: 'CANCELANDO_INTENTOS_DE_PAGO',
  checkoutNewAddress: 'CHECKOUT_NEW_ADDRESS',
  comprarGuia: 'COMPRAR_GUIA',
  comprarGuiaClipDialog: 'COMPRAR_GUIA_CLIP_DIALOG',
  comprarGuiaLocker: 'COMPRAR_GUIA_LOCKER',
  comprarRecargasYServicios: 'COMPRAR_RECARGAS_SERVICIOS',
  crearMpPreferece: 'CREAR_MP_PREFERENCE',
  crearMPToken: 'CREACION_MP_TOKEN',
  crearReembolso: 'CREAR_REEMBOLSO',
  envioItemLocker: 'ENVIO_ITEM_LOCKER',
  errorComprarGuia: 'CHECKOUT_PAYMENT',
  errorComprarGuiaClip: 'CHECKOUT_PAYMENT_CLIP',
  estadoPuntoDePago: 'OBTENIENDO_STATUS_PUNTO_DE_PAGO',
  getDevices: 'OBTENIENDO_DEVICES',
  getPayment: 'OBTENER_STATUS_DEL_PAGO',
  getPaymentByExternalReference: 'OBTENER_PAGO_POR_REFERENCIA_EXTERNA',
  getPaymentPoint: 'OBTENER_INTENCION_DE_PAGO',
  hacerCotizacion: 'HACER_COTIZACION',
  intentosDePago: 'CREANDO_INTENTOS_DE_PAGO',
  manualAction: 'ACCION_MANUAL',
  movimientoEmpaque: 'MOVIMIENTO_EMPAQUE_SALDO_DIALOG',
  obteniendoSaldosEmida: 'OBTENIENDO_SALDOS_EMIDA',
  pagoRecarcasYservicios: 'PAGO_RECARGAS_Y_SERVICios',
  pedirReporteABackend: 'PEDIR_REPORTE_BACKEND',
  saldoQr: 'CREACION_REFERENCIA_QR',
  statusDePantalla: 'OBTENIENDO_STATUS_PANTALLA',
  tomandoMedidasLocker: 'TOMA_MEDIDAS',
  direccionesReporte: 'REPORTE_DIRECCIONES',
  enviarRecibo: 'ENVIAR_RECIBO'
};

// coleccion 'errorReports'

export const statusAction = {
  pending: 'PENDING',
  solved: 'SOLVED'
};
